import { render, staticRenderFns } from "./ToggleTextArea.vue?vue&type=template&id=44838eaf&scoped=true&"
import script from "./ToggleTextArea.vue?vue&type=script&lang=js&"
export * from "./ToggleTextArea.vue?vue&type=script&lang=js&"
import style0 from "./ToggleTextArea.vue?vue&type=style&index=0&id=44838eaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44838eaf",
  null
  
)

export default component.exports